import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Ecommerce.css";
import ecom1 from "../../images/ecom1.png";
import ecom2 from "../../images/ecom2.png";

const Ecommerce = (props) => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slideToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <>
      <hr className="hr" />
      <div className="ecomContainer">
        <h1 className="ecommerceHeading">E-commerce</h1>
        <div className="ecomText">
          <p>
            E-Commerce mockup website, fully functional site coded in Reactjs &
            Redux. User is able to add a product to the shopping cart, visit the
            cart page, increase/decrease the quantity, remove the product from
            cart and of course the price updates depending on the action taken
          </p>
        </div>
        <div className="ecomWrapper">
          <Slider {...settings}>
            <div className="sliderDiv">
              <img src={ecom1} alt="" />
            </div>
            <div className="sliderDiv">
              <img src={ecom2} alt="" />
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Ecommerce;
